import { trackEvent } from '@/infra/tracking/analytics'
import { safeTrackCall } from '@/presentation/pages/common-analytics'

export namespace Analytics {
  export const trackNavigate = safeTrackCall(async (destination: string) => {
    if (!destination) return

    trackEvent('up_header_navigate', {
      destination: destination.toLowerCase()
    })
  })

  export const trackOpenOptionMenu = safeTrackCall(async (option: string) => {
    if (!option) return

    trackEvent('up_header_openOptionMenu', {
      option: option.toLowerCase()
    })
  })

  export const trackUserMenu = safeTrackCall(async (open: boolean) => {
    trackEvent('up_header_userMenu', {
      open
    })
  })

  export const trackNavMenu = safeTrackCall(async (open: boolean) => {
    trackEvent('up_header_navMenu', {
      open
    })
  })
}
